import { ProductClassification } from "interfaces";
import { get, patch, post, remove } from "services/services.methods";
import { ProductClassificationPaths } from "services/services.paths";

export const getProductClasification = async () => {
  const response = await get<ProductClassification[]>(
    ProductClassificationPaths.get
  );

  return response.data;
};

export const deleteProductClasification = async (id: number) => {
  const response = await remove<any>(
    ProductClassificationPaths.delete + `/${id}`
  );

  return response;
};

export const editProductClassification = async (payload: any, id: number) => {
  const response = await patch<any>(
    ProductClassificationPaths.put + `/${id}`,
    payload
  );

  return response;
};

export const createProductClassification = async (payload: any) => {
  const response = await post<any>(ProductClassificationPaths.post, payload);

  return response;
};
